import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './core/layout/layout.component';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () =>
            import('./features/login/login.component').then((m) => m.LoginComponent),
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                loadComponent: () =>
                    import('./features/dashboard/dashboard.component').then(
                        (m) => m.DashboardComponent,
                    ),
            },
            {
                path: 'users',
                loadChildren: () =>
                    import('./features/users/users.routes').then((m) => m.USER_ROUTES),
            },
            {
                path: 'teams',
                loadChildren: () =>
                    import('./features/teams/teams.routes').then((m) => m.TEAM_ROUTES),
            },
            {
                path: 'roles',
                loadChildren: () =>
                    import('./features/roles/roles.routes').then((m) => m.ROLE_ROUTES),
            },
            {
                path: 'locations',
                loadChildren: () =>
                    import('./features/locations/locations.routes').then((m) => m.LOCATION_ROUTES),
            },
            {
                path: 'asset-categories',
                loadChildren: () =>
                    import('./features/asset-categories/asset-categories.routes').then(
                        (m) => m.ASSET_CATEGORY_ROUTES,
                    ),
            },
            {
                path: 'sub-locations',
                loadChildren: () =>
                    import('./features/sub-locations/sub-locations.routes').then(
                        (m) => m.SUB_LOCATION_ROUTES,
                    ),
            },
            {
                path: 'sub-location-details',
                loadChildren: () =>
                    import('./features/sub-location-details/sub-location-details.routes').then(
                        (m) => m.SUB_LOCATION_DETAIL_ROUTES,
                    ),
            },
            {
                path: 'work-orders',
                loadChildren: () =>
                    import('./features/work-orders/work-orders.routes').then(
                        (m) => m.WORK_ORDER_ROUTES,
                    ),
            },
            {
                path: 'monitoring',
                loadChildren: () =>
                    import('./features/monitoring/monitoring.routes').then(
                        (m) => m.MONITORING_ROUTES,
                    ),
            },
            {
                path: 'reports',
                loadChildren: () =>
                    import('./features/reports/reports.routes').then((m) => m.REPORT_ROUTES),
            },
            {
                path: 'clock-sessions',
                loadChildren: () =>
                    import('./features/clock-sessions/clock-sessions.routes').then(
                        (m) => m.CLOCK_SESSION_ROUTES,
                    ),
            },
            {
                path: 'stock-opname-results',
                loadChildren: () =>
                    import('./features/stock-opname-results/stock-opname-results.routes').then(
                        (m) => m.STOCK_OPNAME_RESULT_ROUTES,
                    ),
            },
            {
                path: 'audit-logs',
                loadChildren: () =>
                    import('./features/audit-logs/audit-logs.routes').then(
                        (m) => m.AUDIT_LOGS_ROUTES,
                    ),
            },
            {
                path: 'settings',
                loadChildren: () =>
                    import('./features/settings/settings.routes').then((m) => m.SETTING_ROUTES),
            },
            {
                path: 'target-plans',
                loadChildren: () =>
                    import('./features/target-plans/target-plans.routes').then(
                        (m) => m.TARGET_PLANS_ROUTES,
                    ),
            },
            {
                path: 'imports',
                loadChildren: () =>
                    import('./features/import-data/import-data.routes').then(
                        (m) => m.IMPORT_DATA_ROUTES,
                    ),
            },
            {
                path: 'account',
                loadComponent: () =>
                    import('./features/account/account.component').then((m) => m.AccountComponent),
            },
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'dashboard',
    },
];
